module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }, [_vm._v("Vehicles")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 3,
      "step": "3"
    }
  }, [_vm._v("Select Products")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 4,
      "step": "4"
    }
  }, [_vm._v("Assign Products")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 5,
      "step": "5"
    }
  }, [_vm._v("Finance")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 6,
      "step": "6"
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pt-5",
    attrs: {
      "step": "1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.customerList,
      "loading": _vm.gettingCustomers,
      "label": "Select a Customer",
      "item-text": "name",
      "hide-details": "",
      "item-value": "key"
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center pb-2 pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("OR")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/Admin/Customer')
      }
    }
  }, [_vm._v("Add New Customer")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.customer,
      "depressed": ""
    },
    on: {
      "click": _vm.step2
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addVehicleDialog = true
      }
    }
  }, [_vm._v("Add Vehicle")]), _vm._v(" "), _c('multi-vehicle-dialog', {
    attrs: {
      "parentCustomer": _vm.customer,
      "customerFixed": true
    },
    on: {
      "vehiclesAdded": _vm.vehiclesAdded
    }
  }), _vm._v(" "), _c('bulk-add-vehicle-dialog', {
    attrs: {
      "parentCustomer": _vm.customer,
      "customerFixed": true
    },
    on: {
      "vehiclesAdded": _vm.vehiclesAdded
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": _vm.selectNew
    }
  }, [_vm._v("Select All New Vehicles")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "primary",
      "disabled": _vm.vehicles.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step3
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search"
    },
    model: {
      value: (_vm.searchVehicles),
      callback: function($$v) {
        _vm.searchVehicles = $$v
      },
      expression: "searchVehicles"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.vehicleList,
      "hide-actions": "",
      "loading": _vm.gettingVehicles,
      "search": _vm.searchVehicles,
      "item-key": "id",
      "select-all": "",
      "headers": [{
        text: 'Row',
        value: 'index',
        sortable: false
      }, {
        text: 'Vehicle ID.',
        value: 'friendlyId',
        sortable: true
      }, {
        text: 'Vehicle Reg.',
        value: 'VehicleReg',
        sortable: true
      }, {
        text: 'Make.',
        value: 'Make',
        sortable: true
      }, {
        text: 'Model.',
        value: 'Model',
        sortable: true
      }, {
        text: 'Year Reg.',
        value: 'Year',
        sortable: true
      }, {
        text: 'Added',
        value: 'Added',
        sortable: true
      }, {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'right'
      }],
      "pagination": _vm.vehiclePagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.vehiclePagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _c('td', {
          style: (props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;')
        }, [_vm._v(_vm._s(props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Make))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(props.item.Added))), (props.item.New == true) ? _c('v-chip', {
          attrs: {
            "color": "green",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("New")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteVehicle(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }]),
    model: {
      value: (_vm.vehicles),
      callback: function($$v) {
        _vm.vehicles = $$v
      },
      expression: "vehicles"
    }
  }, [_vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "error",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n                    Your search for \"" + _vm._s(_vm.searchVehicles) + "\" found no results.\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step1
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.vehicles.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step3
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.selectedTemplates.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step4
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Products to Install")]), _vm._v(" "), _c('v-treeview', {
    attrs: {
      "items": _vm.productsTreeView,
      "multiple-active": "",
      "activatable": "",
      "active-class": "primary--text font-weight-black",
      "open-on-click": "",
      "active": _vm.checkedTemplates
    },
    on: {
      "update:active": function($event) {
        _vm.checkedTemplates = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function(ref) {
        var item = ref.item;
        var open = ref.open;
        var active = ref.active;

        return [(!item.child) ? _c('v-icon', [_vm._v("\n                        " + _vm._s(open ? 'mdi-folder-open' : 'mdi-folder') + "\n                      ")]) : (active) ? _c('v-icon', [_vm._v("mdi-check")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step2
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.selectedTemplates.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step4
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step5
    }
  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.newVehicleData,
      "hide-actions": "",
      "loading": _vm.gettingVehicleData,
      "search": _vm.searchVehicleData,
      "item-key": "id",
      "pagination": _vm.pagination,
      "headers": _vm.vehicleDataHeaders
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : ''],
            staticStyle: {
              "position": "sticky",
              "top": "0",
              "background": "white",
              "z-index": "99"
            },
            style: (header.align ? 'text-align:' + header.align : ''),
            on: {
              "click": function($event) {
                return _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("arrow_upward")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(header.text))])], 1)
        }), 0), _vm._v(" "), _c('tr', _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : ''],
            style: (header.align ? 'text-align:' + header.align : '')
          }, [(header.class && header.class.indexOf('group-header') !== -1 && header.hasExtras) ? _c('v-btn', {
            attrs: {
              "small": "",
              "icon": "",
              "flat": header.class && header.class.indexOf('show') === -1,
              "color": "primary"
            },
            on: {
              "click": function($event) {
                return _vm.toggleGroup(header.value)
              }
            }
          }, [_c('v-icon', {
            staticClass: "group-hide-icon",
            attrs: {
              "color": header.class && header.class.indexOf('show') === -1 ? 'primary' : 'white'
            }
          }, [_vm._v("add")])], 1) : _vm._e()], 1)
        }), 0)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [(props.index === 0) ? _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.selectedTemplates), function(template, index) {
          return [_c('td', {
            key: 'checkAll-' + index,
            staticClass: "text-xs-center"
          }, [_c('v-checkbox', {
            staticClass: "text-xs-center",
            attrs: {
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeInstalledDeviceAll(template.id)
              }
            },
            model: {
              value: (_vm.allItemsInstalledDevices[template.id]),
              callback: function($$v) {
                _vm.$set(_vm.allItemsInstalledDevices, template.id, $$v)
              },
              expression: "allItemsInstalledDevices[template.id]"
            }
          })], 1), _vm._v(" "), _vm._l((template.extras), function(templateExtra, extraIndex) {
            return [(templateExtra.permissions.sales === 'write') ? _c('td', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (template.visible),
                expression: "template.visible"
              }],
              key: 'x-' + index + '-' + extraIndex,
              class: (!_vm.allItemsInstalledDevices[template.id] ? 'grey lighten-2 ' : '') + 'col-' + template.id
            }, [(_vm.allItemsInstalledDevices[template.id] && templateExtra.permissions.sales === 'write') ? _c('v-edit-dialog', {
              attrs: {
                "return-value": _vm.allItems[template.id][templateExtra.name],
                "large": "",
                "lazy": "",
                "persistent": ""
              },
              on: {
                "update:returnValue": function($event) {
                  return _vm.$set(_vm.allItems[template.id], templateExtra.name, $event)
                },
                "update:return-value": function($event) {
                  return _vm.$set(_vm.allItems[template.id], templateExtra.name, $event)
                },
                "save": function($event) {
                  return _vm.changeExtraAll(template.id, templateExtra.name)
                }
              }
            }, [_c('div', [_vm._v(_vm._s(_vm.allItems[template.id][templateExtra.name]))]), _vm._v(" "), (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice') ? _c('v-select', {
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "items": _vm.selectedTemplates[index]['extras'][extraIndex]['options'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true,
                "clearable": _vm.selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false
              },
              slot: "input",
              model: {
                value: (_vm.allItems[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(_vm.allItems[template.id], templateExtra.name, $$v)
                },
                expression: "allItems[template.id][templateExtra.name]"
              }
            }) : (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'text') ? _c('v-text-field', {
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "text",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (_vm.allItems[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(_vm.allItems[template.id], templateExtra.name, $$v)
                },
                expression: "allItems[template.id][templateExtra.name]"
              }
            }) : _c('v-text-field', {
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "number",
                "step": _vm.selectedTemplates[index]['extras'][extraIndex]['step'],
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (_vm.allItems[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(_vm.allItems[template.id], templateExtra.name, $$v)
                },
                expression: "allItems[template.id][templateExtra.name]"
              }
            })], 1) : [_vm._v(_vm._s(_vm.allItems[template.id][templateExtra.name]))]], 2) : _vm._e()]
          })]
        })], 2) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
          style: (['cursor:pointer;', props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;']),
          on: {
            "click": function($event) {
              return _vm.updateVehicleRegDialog(props.item.id)
            }
          }
        }, [_vm._v(_vm._s(props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _vm._l((_vm.selectedTemplates), function(template, index) {
          return [_c('td', {
            key: props.item.id + '-' + index,
            staticClass: "text-xs-center"
          }, [_c('v-checkbox', {
            staticClass: "text-xs-center",
            attrs: {
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeInstalledDevice(props.item.id, template.id)
              }
            },
            model: {
              value: (props.item.installedDevices[template.id]),
              callback: function($$v) {
                _vm.$set(props.item.installedDevices, template.id, $$v)
              },
              expression: "props.item.installedDevices[template.id]"
            }
          })], 1), _vm._v(" "), _vm._l((template.extras), function(templateExtra, extraIndex) {
            return [(templateExtra.permissions.sales === 'write') ? _c('td', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (template.visible),
                expression: "template.visible"
              }],
              key: props.item.id + '-' + index + '-' + extraIndex,
              class: (props.item.installedDevices[template.id] && props.item.devices[template.id] && props.item.devices[template.id][templateExtra.name] === '' ? 'blue lighten-4 ' : '') + (!props.item.installedDevices[template.id] ? 'grey lighten-2 ' : '') + 'col-' + template.id,
              staticStyle: {
                "border": "solid 1px #eee!important"
              }
            }, [(props.item.devices[template.id] && templateExtra.permissions.sales === 'write') ? _c('v-edit-dialog', {
              ref: 'edit-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "return-value": props.item.devices[template.id][templateExtra.name],
                "large": "",
                "lazy": "",
                "persistent": ""
              },
              on: {
                "update:returnValue": function($event) {
                  return _vm.$set(props.item.devices[template.id], templateExtra.name, $event)
                },
                "update:return-value": function($event) {
                  return _vm.$set(props.item.devices[template.id], templateExtra.name, $event)
                },
                "open": function($event) {
                  _vm.openEditDialog(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))
                },
                "save": function($event) {
                  _vm.nextRow(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))
                }
              }
            }, [_c('div', [_vm._v(_vm._s(props.item.devices[template.id][templateExtra.name]))]), _vm._v(" "), (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice') ? _c('v-select', {
              ref: 'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "items": _vm.selectedTemplates[index]['extras'][extraIndex]['options'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true,
                "clearable": _vm.selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false
              },
              slot: "input",
              model: {
                value: (props.item.devices[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(props.item.devices[template.id], templateExtra.name, $$v)
                },
                expression: "props.item.devices[template.id][templateExtra.name]"
              }
            }) : (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'text') ? _c('v-text-field', {
              ref: 'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "text",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (props.item.devices[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(props.item.devices[template.id], templateExtra.name, $$v)
                },
                expression: "props.item.devices[template.id][templateExtra.name]"
              }
            }) : _c('v-text-field', {
              ref: 'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "number",
                "step": _vm.selectedTemplates[index]['extras'][extraIndex]['step'],
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (props.item.devices[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(props.item.devices[template.id], templateExtra.name, $$v)
                },
                expression: "props.item.devices[template.id][templateExtra.name]"
              }
            })], 1) : [_vm._v(_vm._s(props.item.devices[template.id] ? props.item.devices[template.id][templateExtra.name] : ''))]], 2) : _vm._e()]
          })]
        })], 2)]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "error",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n                Your search for \"" + _vm._s(_vm.searchVehicleData) + "\" found no results.\n              ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step3
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step5
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "5"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step6
    }
  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Finance")]), _vm._v(" "), _vm._l((_vm.selectedTemplates), function(template) {
    return _c('div', {
      key: template.id,
      staticClass: "my-3"
    }, [_c('h4', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('v-select', {
      attrs: {
        "multiple": "",
        "items": _vm.paymentMethods,
        "chips": "",
        "label": "Payment Method(s)"
      },
      model: {
        value: (_vm.finance[template.id]['paymentMethods']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'paymentMethods', $$v)
        },
        expression: "finance[template.id]['paymentMethods']"
      }
    }), _vm._v(" "), _c('v-select', {
      attrs: {
        "label": "Contact Term",
        "items": _vm.contractTerms
      },
      model: {
        value: (_vm.finance[template.id]['contractTerm']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'contractTerm', $$v)
        },
        expression: "finance[template.id]['contractTerm']"
      }
    }), _vm._v(" "), _c('v-select', {
      attrs: {
        "label": "Currency",
        "items": _vm.currencies
      },
      model: {
        value: (_vm.finance[template.id]['currency']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'currency', $$v)
        },
        expression: "finance[template.id]['currency']"
      }
    }), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('upfront-payment')) ? _c('v-text-field', {
      attrs: {
        "label": "Upfront Payment Per Unit",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['upfrontPayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'upfrontPayment', $$v)
        },
        expression: "finance[template.id]['upfrontPayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('upfront-installation')) ? _c('v-text-field', {
      attrs: {
        "label": "Installation Payment Per Unit",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['installationPayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'installationPayment', $$v)
        },
        expression: "finance[template.id]['installationPayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('rental')) ? _c('v-text-field', {
      attrs: {
        "label": "Rental Payment Per Unit",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['rentalPayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'rentalPayment', $$v)
        },
        expression: "finance[template.id]['rentalPayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('rental')) ? _c('v-select', {
      attrs: {
        "label": "Rental Frequency",
        "items": _vm.rentalFrequencies
      },
      model: {
        value: (_vm.finance[template.id]['rentalFrequency']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'rentalFrequency', $$v)
        },
        expression: "finance[template.id]['rentalFrequency']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('lease')) ? _c('v-select', {
      attrs: {
        "label": "lessor",
        "items": _vm.lessors
      },
      model: {
        value: (_vm.finance[template.id]['lessor']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'lessor', $$v)
        },
        expression: "finance[template.id]['lessor']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('lease')) ? _c('v-text-field', {
      attrs: {
        "label": "Lease Payment Per Unit",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['leasePayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'leasePayment', $$v)
        },
        expression: "finance[template.id]['leasePayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('lease')) ? _c('v-select', {
      attrs: {
        "label": "Lease Frequency",
        "items": _vm.leaseFrequencies
      },
      model: {
        value: (_vm.finance[template.id]['leaseFrequency']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'leaseFrequency', $$v)
        },
        expression: "finance[template.id]['leaseFrequency']"
      }
    }) : _vm._e(), _vm._v(" "), _c('v-select', {
      attrs: {
        "label": "Warranty",
        "items": _vm.warranties
      },
      model: {
        value: (_vm.finance[template.id]['warranty']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'warranty', $$v)
        },
        expression: "finance[template.id]['warranty']"
      }
    }), _vm._v(" "), (_vm.finance[template.id]['warranty'] !== 'n/a') ? _c('v-select', {
      attrs: {
        "label": "Warranty Type",
        "items": _vm.warrantyType
      },
      model: {
        value: (_vm.finance[template.id]['warrantyType']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'warrantyType', $$v)
        },
        expression: "finance[template.id]['warrantyType']"
      }
    }) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step4Back
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step6
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.contactDialog = true
      }
    }
  }, [_vm._v("Add Contact")])], 1), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.contacts,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "item-text": "Name",
      "item-value": "id",
      "label": "Relevant Contacts",
      "hint": "Please select any contacts that are relevant to this project."
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.Name)), _vm._l((data.item.Site), function(site) {
            return [(_vm.sites[site]) ? _c('v-chip', {
              key: site,
              staticClass: "pb-1",
              attrs: {
                "label": "",
                "small": ""
              }
            }, [_vm._v(_vm._s(_vm.sites[site].Name))]) : _vm._e()]
          })], 2)], 1)]
        ]
      }
    }]),
    model: {
      value: (_vm.selectedContacts),
      callback: function($$v) {
        _vm.selectedContacts = $$v
      },
      expression: "selectedContacts"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 5
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": "",
      "disabled": _vm.attachedDocs.length < 2 || _vm.qnq.length < 1 || _vm.selectedContacts.length < 1
    },
    on: {
      "click": _vm.saveCtnSheetDialog
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Attached Documents")]), _vm._v(" "), _c('upload-btn', {
    attrs: {
      "title": 'Attach New Document',
      "fileChangedCallback": _vm.attachFile
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-paperclip")])], 1)], 2), _vm._v(" "), (_vm.attachedDocs.length < 2) ? _c('v-chip', {
    attrs: {
      "label": "",
      "outline": "",
      "color": "red"
    }
  }, [_vm._v(_vm._s((2 - _vm.attachedDocs.length) + ' doc') + _vm._s(_vm.attachedDocs.length == 0 ? 's' : '') + _vm._s(' required (GP sheet & SIGNED order form)'))]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', _vm._l((_vm.attachedDocs), function(fileObj, key) {
    return _c('v-list-tile', {
      key: fileObj.file.name,
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "color": "error",
        "disabled": _vm.savingCtnSheet
      },
      on: {
        "click": function($event) {
          return _vm.attachedDocs.splice(key, 1)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v(_vm._s(fileObj.file.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption ml-1"
    }, [_vm._v(_vm._s(_vm._f("formatBytes")(fileObj.file.size)))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('v-progress-linear', {
      attrs: {
        "value": fileObj.Progress,
        "color": fileObj.State === 0 ? 'primary' : fileObj.State === 1 ? 'blue' : fileObj.State === 2 ? 'warning' : fileObj.State === 3 ? 'success' : fileObj.State === 4 ? 'error' : 'primary'
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.qnq.length < 1 ? 'QNQ number is required' : '',
      "error": _vm.qnq.length < 1,
      "outline": "",
      "label": "QNQ Number"
    },
    model: {
      value: (_vm.qnq),
      callback: function($$v) {
        _vm.qnq = $$v
      },
      expression: "qnq"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outline": "",
      "label": "Customer PO"
    },
    model: {
      value: (_vm.customerPO),
      callback: function($$v) {
        _vm.customerPO = $$v
      },
      expression: "customerPO"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.ctnSheetDialog),
      callback: function($$v) {
        _vm.ctnSheetDialog = $$v
      },
      expression: "ctnSheetDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Submit Order")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "label": "Order Note",
      "value": _vm.ctnSheetNote,
      "rows": "3",
      "auto-grow": ""
    },
    on: {
      "change": function (v) { return _vm.ctnSheetNote = v; }
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": "",
      "loading": _vm.savingCtnSheet
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveCtnSheet($event)
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": "",
      "disabled": _vm.savingCtnSheet
    },
    nativeOn: {
      "click": function($event) {
        _vm.ctnSheetDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.submittedDialog),
      callback: function($$v) {
        _vm.submittedDialog = $$v
      },
      expression: "submittedDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Connection Sheet Submitted")]), _vm._v(" "), _c('v-card-text', [_vm._v("The connection sheet has been submitted for approval by support. Reference No: " + _vm._s(_vm.submittedRef) + ".")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.vehicleRegDialog),
      callback: function($$v) {
        _vm.vehicleRegDialog = $$v
      },
      expression: "vehicleRegDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update Vehicle Registration")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    ref: "updateVehicleRegInput",
    attrs: {
      "label": "Vehicle Reg.",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveVehicleReg($event)
      }
    },
    model: {
      value: (_vm.vehicleRegDialogData.Reg),
      callback: function($$v) {
        _vm.$set(_vm.vehicleRegDialogData, "Reg", $$v)
      },
      expression: "vehicleRegDialogData.Reg"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": ""
    },
    on: {
      "click": _vm.saveVehicleReg
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.vehicleRegDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('new-vehicle-dialog', {
    attrs: {
      "dialog": _vm.addVehicleDialog,
      "customer": _vm.customer
    },
    on: {
      "vehicleAdded": _vm.newVehicleAdded,
      "update:dialog": function($event) {
        _vm.addVehicleDialog = $event
      }
    }
  }), _vm._v(" "), _c('contact-edit-dialog', {
    attrs: {
      "contactID": null,
      "customer": _vm.customer,
      "customers": _vm.customerObj,
      "contactDialog": _vm.contactDialog
    },
    on: {
      "getContacts": _vm.step6,
      "update:contactDialog": function($event) {
        _vm.contactDialog = $event
      },
      "update:contact-dialog": function($event) {
        _vm.contactDialog = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e36b6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewOrder.vue
// module id = 738
// module chunks = 1